<template>
<v-container class="margen_paginas pt-7" fluid>

    <v-card class="mb-n4" style="background-color: #E8EAF6;">
      <v-card-title class="pa-2 pl-4" style="background: #b0b0c0">
        <v-icon class="mr-3">mdi-database-import</v-icon>
        <span style="font-size: 20px; font-weight: 400">{{ $t ('Importación de datos') }}</span>
      </v-card-title>

      <v-container class="pa-7" fluid style="background: #dcdcd0; border-bottom: 1px solid #BBBBBB">
        <v-row>
          <!-- aparcamiento -->
          <v-col class="pa-0">
            Seleccione el fichero (.json) con datos SAGA a importar:
             <CampoFicheroDataURL
              truncate-length="160"
              v-model="jsonAImportar"
              :disabled="importandoDatos"
              hide-details
            ></CampoFicheroDataURL>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="pa-7" v-if="datosAImportar" fluid>
        <template v-if="seleccionDatos">
          <v-row>
            <v-col cols="12" class="pa-0">
              Datos a importar:
              <v-checkbox :style="{ marginLeft: elemento.i * 18 + 'px' }" class="mt-1" v-for="elemento in seleccionDatos" :key="elemento.titulo" :label="elemento.titulo" v-model="elemento.incluir" :disabled="importandoDatos || resultado" hide-details />
              <v-btn class="mt-5" @click="clickImportar" :loading="importandoDatos" :disabled="importandoDatos || resultado" >Importar</v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col class="pa-0">
              No se han encontrado datos para importar
            </v-col>
          </v-row>
        </template>

        <template v-if="resultado">
          <v-row class="pt-4">
            <v-col cols="12" class="pa-0">
              <hr class="mb-3">
              Resultado de la importación:
              <div class="mt-2" style="font-family: monospace; font-size: 13px" v-html="resultado" />
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>

  </v-container>
</template>

<script>
import CampoFicheroDataURL from '@/components/CampoFicheroDataURL.vue';
import api from "@/api";

export default {
  components: { CampoFicheroDataURL },
  data() {
    return {
      jsonAImportar: null,
      datosAImportar: null,
      seleccionDatos: null,
      importandoDatos: false,
      resultado: null,
    }
  },
  watch: {
    jsonAImportar() {
      this.datosAImportar = null;
      this.seleccionDatos = null;
      this.resultado = null;

      let aux = Buffer.from(this.jsonAImportar.split(",")[1], 'base64');
      this.datosAImportar = JSON.parse (aux);

      this.seleccionDatos = [
        { i: 0, titulo: "Instalación: " + this.datosAImportar.ins.cod + " - " + this.datosAImportar.ins.nom, clave: "ins", incluir: true },
        { i: 1, titulo: "Operadores (" + (this.datosAImportar.ins.ope ?? []).length + ")", clave: "ope", incluir: true },
        { i: 1, titulo: "Aparatos (" + (this.datosAImportar.ins.apa ?? []).length + ")", clave: "apa", incluir: true },
        { i: 1, titulo: "Zonas (" + (this.datosAImportar.ins.zon ?? []).length + ")", clave: "zon", incluir: true },
        // { i: 1, titulo: "Contadores (" + (this.datosAImportar.ins.con ?? []).length + ")", clave: "con", incluir: true },
        // { i: 1, titulo: "Carteles (" + (this.datosAImportar.ins.car ?? []).length + ")", clave: "car", incluir: true },
        // { i: 1, titulo: "Festivos (" + (this.datosAImportar.ins.fes ?? []).length + ")", clave: "fes", incluir: true },
        // { i: 1, titulo: "Horarios (" + (this.datosAImportar.ins.hor ?? []).length + ")", clave: "hor", incluir: true },
        { i: 1, titulo: "Listas de precios (" + (this.datosAImportar.ins.lispre ?? []).length + ")", clave: "lispre", incluir: true },
        { i: 1, titulo: "Tarifas (" + (this.datosAImportar.ins.tar ?? []).length + ")", clave: "tar", incluir: true },
        // { i: 1, titulo: "Grupos de productos (" + (this.datosAImportar.ins.grupro ?? []).length + ")", clave: "grupro", incluir: true },
        // { i: 1, titulo: "Politicas de acceso (" + (this.datosAImportar.ins.polacc ?? []).length + ")", clave: "polacc", incluir: true },
        // { i: 1, titulo: "Grupos de clientes (" + (this.datosAImportar.ins.grucli ?? []).length + ")", clave: "grucli", incluir: true },
        { i: 1, titulo: "Clientes (" + (this.datosAImportar.ins.cli ?? []).length + ")", clave: "cli", incluir: true },
        { i: 2, titulo: "Productos de clientes", clave: "proencir", incluir: true },
        { i: 2, titulo: "Vehiculos de clientes", clave: "vehcli", incluir: true },
      ];
    }
  },
  methods: {
    clickImportar() {
      let json_peticion = {
        seleccionDatos: this.seleccionDatos,
        datosAImportar: this.datosAImportar,
      }
      this.importandoDatos = true;
      api.importarDatosSAGA (json_peticion)
        .then ((resultado)=> {
          this.resultado = resultado.data;
        })
        .finally(() => {
          this.importandoDatos = false;
        });
    }
  }
};
</script>

<style>
</style>